import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Button } from '../../../../ui/widgets/button/button';

const styles = require('./message.css');

/** Props for the component */
export interface MessageProps {
  /** Additional classes to apply */
  className?: string;
  /** Title of the notification */
  title: string;
  /** Type of message - error or notification */
  kind?: 'error' | 'notification';
  /** Body describing the notification */
  body: string;
  /** First button definition */
  button1?: ButtonProps;
  /** Second button definition */
  button2?: ButtonProps;
}

/** Props for a button */
export interface ButtonProps {
  /** Label to show */
  label: string;
  /** Callback on click */
  onClick(): Promise<void>;
}

/**
 * Prominent banner alerting user to something important, e.g. notifications.
 */
@observer
export class Message extends React.Component<MessageProps> {
  /** Renders a button */
  renderButton(button: ButtonProps, labelStyle: string) {
    return (
      <Button
        className={styles.button}
        textClassName={labelStyle}
        size="small"
        variant="tertiary"
        onClick={button.onClick}
      >
        {button.label}
      </Button>
    );
  }
  /** Renders the component */
  render() {
    const kind = this.props.kind || 'notification';
    let barStyle = styles.bar;
    let titleStyle = styles.title;
    let buttonLabelStyle = styles.buttonLabel;
    if (kind === 'error') {
      barStyle = classnames(styles.bar, styles.errorBkgd);
      titleStyle = classnames(styles.title, styles.errorColour);
      buttonLabelStyle = classnames(styles.buttonLabel, styles.errorColour);
    }
    return (
      <div className={classnames(styles.container, this.props.className)}>
        <div className={barStyle} />
        <div className={styles.contentAndButtons}>
          <div className={styles.content}>
            <h4 className={titleStyle}>{this.props.title}</h4>
            {this.props.body}
            {this.props.children}
          </div>
          <div className={styles.buttons}>
            {this.props.button1 ? this.renderButton(this.props.button1, buttonLabelStyle) : undefined}
            {this.props.button2 ? this.renderButton(this.props.button2, buttonLabelStyle) : undefined}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/widgets/message/message.tsx